<template>
	<div class="container pb_0">
		<div class="main">
			<p class="text_t type1">JPYS 자체 포인트 시스템</p>
			<p class="text_n">
				빠르고 안전한 자체 포인트 시스템<br />
				고정 된 환율로 피곤함이 없습니다.
			</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.asset_send') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>

		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box">
					<div class="bg_text_area tac">
						<p class="text_t type2 mb_30 pt_100">모든 시스템과 연동</p>
						<p class="text_n">
							오프라인 매장 및 온라인 스토어<br />
							모두 JPYS 하나만 있으면 다 됩니다.
						</p>
					</div>
					<div class="icon_box">
						<div class="box1"></div>
						<div class="box2"></div>
					</div>
				</div>

				<div class="bg_box border_r_16 mb_16">
					<div class="bg_text_area left">
						<p class="text_t fc_white">
							키오스크 및 포스기<br />
							어디에서나 결제를 자유롭게
						</p>
					</div>
				</div>

				<div class="bg_box bg_white">
					<div class="bg_text_area right tac">
						<p class="text_t">편리한 충전</p>
						<p class="text_n">
							원하는 암호자산 및 신용카드로<br />
							즉시 충전이 가능합니다.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Jpys',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
